import { combineReducers, configureStore } from "@reduxjs/toolkit";

import { authSlice } from "@/app/auth/auth.slice";
import { api } from "@/app/app.api";

import { paymentSlice } from "./payments/payment.slice";
import branchReducer from "@/app/branchs/branch.slice"; // Importa el reducer de la branch
import { countriesApi } from "@/app/app.apiCountry";
import { statesApi } from "@/app/app.apiStates";
import { chatSlice } from "./chat/chat.slice";

export const store = configureStore({
  devTools: true,
  reducer: combineReducers({
    [authSlice.name]: authSlice.reducer,
    [chatSlice.name]: chatSlice.reducer,
    [paymentSlice.name]: paymentSlice.reducer,
    branch: branchReducer,

    [api.reducerPath]: api.reducer,
    [countriesApi.reducerPath]: countriesApi.reducer,
    [statesApi.reducerPath]: statesApi.reducer,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(api.middleware)
      .concat(countriesApi.middleware)
      .concat(statesApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => store.dispatch;
